// extracted by mini-css-extract-plugin
export default {"modal":"sNFtgFOtj3H7vcMJl_NK"};